import type { FaireProductEntity } from "../../entity_types/product";

export const p_4q6pqqdsyx: FaireProductEntity = {
  token: "p_4q6pqqdsyx",
  type: "product",
  name: "LOW WAIST MACRAME MESH MAXI SKIRT",
  brandToken: "b_22tswwgnqb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/84fd5e87c23e09eece8feb3b1bd729c298f79b083c724ece19c0acba6cb2070c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9a5fcaf03a5d0d4aabe8f398208815859e86f8425a98b506ad42366bc1e0a8a0.jpeg",
    "https://cdn.faire.com/fastly/a89687a7120451c70bcbe7c8eb5cb0e251069fc1a2609554af522a2d36db3800.jpeg",
    "https://cdn.faire.com/fastly/e7bec4cb80ced8c8a667c29a149b0f1858ebf0b6bb93b983713808d8eeb60d6e.jpeg",
    "https://cdn.faire.com/fastly/0588c1bbd48d6b70872215ae7177de0e691b29897f20e826c7cac75444eb5164.jpeg",
    "https://cdn.faire.com/fastly/c8885d044fc06b150fb71404a63da6728316d4130f1ba6b371920dd9ca272a9c.jpeg",
    "https://cdn.faire.com/fastly/41040bf20952a20b11fafc8e86344467eea3de5d1aec6c14f1c3437b12043b79.jpeg",
    "https://cdn.faire.com/fastly/4b5f67bedfe156c5bce45f326f4c1a959fa23f5592e2adcc113902c2ae345332.jpeg",
  ],
  priceDollars: 166.28,
  description: "SIZE & FIT :\n\nMODEL WEARS SIZE SMALL\nMODEL'S HEIGHT 5'9",
  tags: [],
  msrpDollars: 332.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:26.812Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
